import { render, staticRenderFns } from "./NotificationView.vue?vue&type=template&id=3ae2fc3d&scoped=true"
import script from "./NotificationView.vue?vue&type=script&lang=js"
export * from "./NotificationView.vue?vue&type=script&lang=js"
import style0 from "./NotificationView.vue?vue&type=style&index=0&id=3ae2fc3d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ae2fc3d",
  null
  
)

export default component.exports